import { Injectable  } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {SiteInfosService} from './site-infos.service';
import {WindowRefService} from '../window-ref.service';
import { PanierService } from './panier.service';
import {GtmService} from './gtm.service';
import {get,find} from "lodash";
import { SearchDispoService } from './search-dispo.service';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})

export class TrackingService {

  rooms : Array<any>;
  checkoutProducts : Array<any>;
  dataLayer : any;
  en_translation : any;
  etabwithPromo : Boolean = false;
  coupon : any = null;

  constructor(
    public translate: TranslateService,
    private winRef: WindowRefService,
    private siteInfoService: SiteInfosService,
    private gtm: GtmService,
    private PanierService:PanierService,
    private searchDispoService:SearchDispoService
  ) {
    this.rooms = [];
    this.checkoutProducts = [];
    this.setTranslation();
  }
  
  calculatePriceFromLine(line) {
    let price = "";
    if(this.winRef.appConfigSite.promo){
      price = (line.engineSelected.combine.detailPrice.Ttc * this.winRef.appConfigSite.Cpercente).toFixed(2);
    } else {
      price = (line.engineSelected.combine.detailPrice_without_promo.Ttc * this.winRef.appConfigSite.Cpercente).toFixed(2);
    }
    return price;
  }

  sendRoomsInfos(rooms) {
    let roomsList = [];
    this.rooms = Array.from(rooms);
    rooms.map((room,roomIndex) => {
      let otas = {booking : "0",agoda : "0",expedia :"0",hotels : "0",bookingbasic : "0"};
      let soldOutRoom = true;
      room.lines.map(line =>{
        if(line.isDispo){
          soldOutRoom = false;
          otas[line.engineSelected.combine.ota] = this.calculatePriceFromLine(line);
        }
      });
      roomsList.push({
        item_name: this.getInstant(room.getTitle(),true),
        item_id: room.id,
        index: roomIndex,
        item_category: soldOutRoom ? "SoldOut-Rooms" : "Available-Rooms",
        item_brand: this.siteInfoService.getEtbaName(),
        list: "List rooms checkprice",
      });
    })
    this.gtm.push({
      event: 'eec.impressionView',
      Hotel_brand_name: this.siteInfoService.getEtbaName(),
      Hotel_City: this.siteInfoService.getEtbaCity(),
      Hotel_Country: this.siteInfoService.getEtbaCountry(),
      Start_date: this.getStartAndEndDates().start,
      End_date: this.getStartAndEndDates().end,
      Adulte: this.winRef.appConfigSite.adults,
      Children: this.winRef.appConfigSite.enfants,
      Hotel_Type: this.siteInfoService.getEtabData()['etabType'],
      Hotel_stars: this.siteInfoService.getEtabData()['etabStars'],
      ecommerce: {
        currency: this.winRef.appConfigSite.Ccurrency,
        items: roomsList
      }
    })
  }

  sendGoogleHotelFinder(nbrAdult, nbrChild, currency) {
    let start = moment(this.winRef.appConfigSite.start).locale('en').format('DD/MM/YYYY');
    let end = moment(this.winRef.appConfigSite.end).locale('en').format('DD/MM/YYYY');
    this.gtm.push({
      event: "google_hotel_finder",
      Hotel_brand_name: this.siteInfoService.getEtbaName(),
      Hotel_City: this.siteInfoService.getEtbaCity(),
      Hotel_Country: this.siteInfoService.getEtbaCountry(),
      Start_date: start,
      End_date: end,
      Adulte: nbrAdult,
      Children: nbrChild,
      Currency: currency,
      Hotel_Type: this.siteInfoService.getEtabData()['etabType'],
      Hotel_stars: this.siteInfoService.getEtabData()['etabStars'],
    })
  }

  getStartAndEndDates() {
    let start = moment(this.winRef.appConfigSite.start).locale('en').format('DD/MM/YYYY');
    let end = moment(this.winRef.appConfigSite.end).locale('en').format('DD/MM/YYYY');
    return {
      start : start,
      end: end
    }
  }

  changeLang() {
    this.gtm.push({
      event: "Change_Langue",
      Hotel_brand_name: this.siteInfoService.getEtbaName(),
      Price_stats: this.etabwithPromo ? "Price advantage" : "Price Match",
      Hotel_City: this.siteInfoService.getEtbaCity(),
      Hotel_Country: this.siteInfoService.getEtbaCountry(),
      Hotel_Type: this.siteInfoService.getEtabData()['etabType'],
      Hotel_stars: this.siteInfoService.getEtabData()['etabStars'],
    });
  }

  changeDevise() {
    this.gtm.push({
      event: "Change_Devise",
      Hotel_brand_name: this.siteInfoService.getEtbaName(),
      Price_stats: this.etabwithPromo ? "Price advantage" : "Price Match",
      Hotel_City: this.siteInfoService.getEtbaCity(),
      Hotel_Country: this.siteInfoService.getEtbaCountry(),
      Hotel_Type: this.siteInfoService.getEtabData()['etabType'],
      Hotel_stars: this.siteInfoService.getEtabData()['etabStars'],
    });
  }

  roomClick(room) {
    this.gtm.push({
      event: "select_item",
      Hotel_brand_name: this.siteInfoService.getEtbaName(),
      Price_stats: this.etabwithPromo ? "Price advantage" : "Price Match",
      Hotel_City: this.siteInfoService.getEtbaCity(),
      Hotel_Country: this.siteInfoService.getEtbaCountry(),
      Hotel_Type: this.siteInfoService.getEtabData()['etabType'],
      Hotel_stars: this.siteInfoService.getEtabData()['etabStars'],
      ecommerce: {
        currency: this.winRef.appConfigSite.Ccurrency,
        items: [
          {
            item_id: room.id,
            item_name: this.getInstant(room.getTitle(),true),
            item_category: "Available-Rooms",
            item_brand: this.siteInfoService.getEtbaName(),
            item_list_id: 'CH1',
            item_list_name: "Checkprice list"
          }
        ]
      }
    })
    this.gtm.push({
      event: "view_item",
      Hotel_brand_name: this.siteInfoService.getEtbaName(),
      Price_stats: this.etabwithPromo ? "Price advantage" : "Price Match",
      Hotel_City: this.siteInfoService.getEtbaCity(),
      Hotel_Country: this.siteInfoService.getEtbaCountry(),
      Hotel_Type: this.siteInfoService.getEtabData()['etabType'],
      Hotel_stars: this.siteInfoService.getEtabData()['etabStars'],
      ecommerce: {
        currency: this.winRef.appConfigSite.Ccurrency,
        items: [
          {
            item_id: room.id,
            item_name: this.getInstant(room.getTitle(),true),
            item_category: "Available-Rooms",
            item_brand: this.siteInfoService.getEtbaName(),
            item_list_id: 'CH1',
            item_list_name: "Checkprice list"
          }
        ]
      }
    })
  }

  getRoomLineVariant(line) {
    let variant =  "adults : "+line.occupation.split('_')[0] + (line.occupation.split('_')[0] != "0" ? (" / children : "+line.occupation.split('_')[1] ) : "");
    if(line.engineSelected.combine.addedvalues){
      for (let index = 0; index < line.engineSelected.combine.addedvalues.length; index++) {
        const element = line.engineSelected.combine.addedvalues[index];
        variant += (" / " + element.name)
      }
    }
    return variant;
  }
  
  toggleRoomInCart(room,line,val) {
    let otas = {booking : 0,agoda : 0,expedia :0,hotels : 0,bookingbasic : 0};
    otas[line.engineSelected.combine.ota] =  parseInt(this.calculatePriceFromLine(line));
    let oldItem = find(this.PanierService.getItems(), {idRoom: room.id, idLine: line.id, occupation: line.occupation});
    if (oldItem) {
      let oldStock = oldItem.stock;
        if(val == 0){
          this.removeFromCart(room,line,otas,oldItem.stock);
        } else if((val > oldStock)){
          this.addToCart(room,line,otas,(val - oldStock));
        } else {
          this.removeFromCart(room,line,otas,(oldStock- val));
        }
    } else {
      this.addToCart(room,line,otas,val);
    }
    this.checkPromo(line);
  }

  checkPromo(line) {
    this.etabwithPromo = line.engineSelected.combine.detailPrice.Ttc != line.engineSelected.combine.detailPrice_without_promo.Ttc;
  }

  addToCart(room,line,otas,quantity) {
    this.gtm.push({
      event: "add_to_cart",
      Hotel_brand_name: this.siteInfoService.getEtbaName(),
      Price_stats: this.etabwithPromo ? "Price advantage" : "Price Match",
      Hotel_City: this.siteInfoService.getEtbaCity(),
      Hotel_Country: this.siteInfoService.getEtbaCountry(),
      Start_date: this.getStartAndEndDates().start,
      End_date: this.getStartAndEndDates().end,
      Adulte: this.winRef.appConfigSite.adults,
      Children: this.winRef.appConfigSite.enfants,
      Hotel_Type: this.siteInfoService.getEtabData()['etabType'],
      Hotel_stars: this.siteInfoService.getEtabData()['etabStars'],
      ecommerce: {
        currency: this.winRef.appConfigSite.Ccurrency,
        items: [{
          item_id: room.id,
          item_name: this.getInstant(room.getTitle(),true),
          price: this.calculatePriceFromLine(line).split('.')[0],
          Sejour: this.winRef.nbrNights(),
          ligneTarif: this.getRoomLineVariant(line),
          Expedia: otas.expedia,
          Booking: otas.booking,
          Agoda: otas.agoda,
          Hotels: otas.hotels,
          BookingB2B: otas.bookingbasic,
          item_brand: this.siteInfoService.getEtbaName(),
          item_category: "Available-Rooms",
          item_variant: this.getInstant(line.getTitelLine(),false),
          quantity: quantity
        }]
      }
    });
  }

  removeFromCart(room,line,otas,quantity) {
    this.gtm.push({
      event: "remove_from_cart",
      Hotel_brand_name: this.siteInfoService.getEtbaName(),
      Price_stats: this.etabwithPromo ? "Price advantage" : "Price Match",
      Hotel_City: this.siteInfoService.getEtbaCity(),
      Hotel_Country: this.siteInfoService.getEtbaCountry(),
      Start_date: this.getStartAndEndDates().start,
      End_date: this.getStartAndEndDates().end,
      Adulte: this.winRef.appConfigSite.adults,
      Children: this.winRef.appConfigSite.enfants,
      Hotel_Type: this.siteInfoService.getEtabData()['etabType'],
      Hotel_stars: this.siteInfoService.getEtabData()['etabStars'],
      ecommerce: {
        currency: this.winRef.appConfigSite.Ccurrency,
        items: [{
          item_id: room.id,
          item_name: this.getInstant(room.getTitle(),true),
          price: this.calculatePriceFromLine(line).split('.')[0],
          Sejour: this.winRef.nbrNights(),
          ligneTarif: this.getRoomLineVariant(line),
          Expedia: otas.expedia,
          Booking: otas.booking,
          Agoda: otas.agoda,
          Hotels: otas.hotels,
          BookingB2B: otas.bookingbasic,
          item_brand: this.siteInfoService.getEtbaName(),
          item_category: "Available-Rooms",
          item_variant: this.getInstant(line.getTitelLine(),false),
          quantity: quantity
        }]
      }
    });
  }

  chekoutProcess(step,params?) {
    this.rooms = Array.from(this.searchDispoService.rooms);
    this.checkoutProducts = this.getCheckoutRoomsProducts(this.PanierService.getItems())
    this.PanierService.getItems().length > 0 ? this.checkPromo(this.PanierService.getItems()[0].line): null;
    if(step == 1){
      this.gtm.push({
        Start_date: this.getStartAndEndDates().start,
        End_date: this.getStartAndEndDates().end,
        Adulte: this.winRef.appConfigSite.adults,
        Children: this.winRef.appConfigSite.enfants,
        Hotel_brand_name: this.siteInfoService.getEtbaName(),
        Price_stats: this.etabwithPromo ? "Price advantage" : "Price Match",
        Hotel_City: this.siteInfoService.getEtbaCity(),
        Hotel_Country: this.siteInfoService.getEtbaCountry(),
        event: "begin_checkout",
        Hotel_Type: this.siteInfoService.getEtabData()['etabType'],
        Hotel_stars: this.siteInfoService.getEtabData()['etabStars'],
        ecommerce: {
          items: this.checkoutProducts,
        }
      })
    }
    if(step == 2) {
      this.gtm.push({
        Start_date: this.getStartAndEndDates().start,
        End_date: this.getStartAndEndDates().end,
        Adulte: this.winRef.appConfigSite.adults,
        Children: this.winRef.appConfigSite.enfants,
        Hotel_brand_name: this.siteInfoService.getEtbaName(),
        Price_stats: this.etabwithPromo ? "Price advantage" : "Price Match",
        Hotel_City: this.siteInfoService.getEtbaCity(),
        Hotel_Country: this.siteInfoService.getEtbaCountry(),
        Client_Mail: params && params.hasOwnProperty("controls") && params.controls.hasOwnProperty("email") ? params.controls['email'].value : 'null',
        event: "add_shipping_info",
        Hotel_Type: this.siteInfoService.getEtabData()['etabType'],
        Hotel_stars: this.siteInfoService.getEtabData()['etabStars'],
        ecommerce: {
          shipping_tier: 'Form',
          items: this.checkoutProducts,
        }
      })
    }
    if(step == 3) {
      this.gtm.push({
        Start_date: this.getStartAndEndDates().start,
        End_date: this.getStartAndEndDates().end,
        Adulte: this.winRef.appConfigSite.adults,
        Children: this.winRef.appConfigSite.enfants,
        Hotel_brand_name: this.siteInfoService.getEtbaName(),
        Price_stats: this.etabwithPromo ? "Price advantage" : "Price Match",
        Hotel_City: this.siteInfoService.getEtbaCity(),
        Hotel_Country: this.siteInfoService.getEtbaCountry(),
        Client_Mail: params && params.hasOwnProperty("controls") && params.controls.hasOwnProperty("email") ? params.controls['email'].value : 'null',
        event: "add_payment_info",
        Hotel_Type: this.siteInfoService.getEtabData()['etabType'],
        Hotel_stars: this.siteInfoService.getEtabData()['etabStars'],
        ecommerce: {
          payment_type: 'CARD',
          items: this.checkoutProducts,
        }
      })
    }
  }

  saveCoupon(coupon) {
    this.coupon = coupon;
  }

  transaction(reservationId,email) {
    let revenue = 0;
    let nuiteeTotal = 0;
    let sejour = this.winRef.nbrNights();
    this.checkoutProducts.map((product,index)=> {
      revenue += (parseInt(product.price) * product.quantity);
      product.Nuitee = (sejour * product.quantity);
      nuiteeTotal += product.Nuitee;
    })
    let afterCheckout = false;
    if(window["dataLayer"]){
      for (let index = 0; index < window["dataLayer"].length; index++) {
        const element = window["dataLayer"][index];
        if(element.event == "begin_checkout"){afterCheckout = true;break;}
      }
    }
    if(afterCheckout){
      this.gtm.push({
        event: "purchase",
        Hotel_brand_name: this.siteInfoService.getEtbaName(),
        Price_stats: this.etabwithPromo ? "Price advantage" : "Price Match",
        Hotel_City: this.siteInfoService.getEtbaCity(),
        Hotel_Country: this.siteInfoService.getEtbaCountry(),
        Start_date: this.getStartAndEndDates().start,
        End_date: this.getStartAndEndDates().end,
        Stays: sejour,
        Nights: nuiteeTotal,
        Client_Mail: email,
        Adulte: this.winRef.appConfigSite.adults,
        Children: this.winRef.appConfigSite.enfants,
        Hotel_Type: this.siteInfoService.getEtabData()['etabType'],
        Hotel_stars: this.siteInfoService.getEtabData()['etabStars'],
        ecommerce: {
          currency: this.winRef.appConfigSite.Ccurrency,
          affiliation: "booking website",
          value: revenue,
          transaction_id: reservationId,
          coupon: this.coupon ? this.coupon : "No coupon" ,
          items: this.checkoutProducts
        }
      });
      this.coupon = null;
    }
  }

  getCheckoutRoomsProducts(cart) {
    let products = [];
    let sejour = this.winRef.nbrNights();
    for (let i = 0; i < cart.length; i++) {
      const cartItem = cart[i];
      if(cartItem.stock > 0) {
        let itemRoom;
        let otas = {booking : 0,agoda : 0,expedia :0,hotels : 0,bookingbasic : 0};
        otas[cartItem.line.engineSelected.combine.ota] = parseInt(this.calculatePriceFromLine(cartItem.line));
        for (let j = 0; j < this.rooms.length; j++) {
          const room = this.rooms[j];
          room.id == cartItem.idRoom ? itemRoom = room : null;
        }
        products.push({
          item_name: this.getInstant(itemRoom.getTitle(),true),
          item_id: cartItem.idRoom,
          price: this.calculatePriceFromLine(cartItem.line).split('.')[0],
          item_brand: this.siteInfoService.getEtbaName(),
          item_category: "Available-Rooms",
          item_variant: this.getInstant(cartItem.line.getTitelLine(),false),
          ligneTarif: this.getRoomLineVariant(cartItem.line),
          quantity: cartItem.stock,
          Booking: otas.booking,
          Agoda: otas.agoda,
          Expedia: otas.expedia,
          Hotels: otas.hotels,
          BookingB2B: otas.bookingbasic,
          Hotel_Type: this.siteInfoService.getEtabData()['etabType'],
          Hotel_stars: this.siteInfoService.getEtabData()['etabStars'],
        })
      }
    }
    return products;
  }

  cancelFullReservation(reservation) {
    let start = moment(reservation.dateDeb).format("DD/MM/YYYY");
    let end = moment(reservation.dateFin).format("DD/MM/YYYY");
    this.gtm.push({
      event: "refund",
      Hotel_brand_name: this.siteInfoService.getEtbaName(),
      Start_date: start,
      End_date: end,
      Price_stats: this.etabwithPromo ? "Price advantage" : "Price Match",
      Hotel_City: this.siteInfoService.getEtbaCity(),
      Hotel_Country: this.siteInfoService.getEtbaCountry(),
      Hotel_Type: this.siteInfoService.getEtabData()['etabType'],
      Hotel_stars: this.siteInfoService.getEtabData()['etabStars'],
      ecommerce: {
        transaction_id: reservation.resaAuth,
        currency: reservation.currency,
        value: (reservation.total*reservation.taux).toFixed(2),
      }
    });
  }

  cancelRoomInReservation(reservation,room) {
    let start = moment(reservation.dateDeb).format("DD/MM/YYYY");
    let end = moment(reservation.dateFin).format("DD/MM/YYYY");
    this.gtm.push({
      event: "refund",
      Hotel_brand_name: this.siteInfoService.getEtbaName(),
      Currency: reservation.currency,
      Start_date: start,
      End_date: end,
      Price_stats: this.etabwithPromo ? "Price advantage" : "Price Match",
      Hotel_City: this.siteInfoService.getEtbaCity(),
      Hotel_Country: this.siteInfoService.getEtbaCountry(),
      Hotel_Type: this.siteInfoService.getEtabData()['etabType'],
      Hotel_stars: this.siteInfoService.getEtabData()['etabStars'],
      ecommerce: {
        transaction_id: reservation.resaAuth,
        items: [
          {
            item_name: this.getInstant(room.objRoom.getTitle(),true),
            item_id: room.idChambre,
            price: room.totalRex,
            item_brand: this.siteInfoService.getEtbaName(),
            item_category: "Available-Rooms",
            quantity: 1,
          }
        ]
      }
    }); 
  }

  compare(position) {
    this.gtm.push({
      event: position == "bottom" ? "compare-bottom" : "compare",
      Hotel_brand_name: this.siteInfoService.getEtbaName(),
      Price_stats: this.etabwithPromo ? "Price advantage" : "Price Match",
      Hotel_City: this.siteInfoService.getEtbaCity(),
      Hotel_Country: this.siteInfoService.getEtbaCountry(),
    });
  }

  changeDates(startDate, endDate, nbrAdult, nbrChild, currency) {
    let start = moment(startDate).format("DD/MM/YYYY");
    let end = moment(endDate).format("DD/MM/YYYY");
    this.gtm.push({
      event: "changeDate",
      Hotel_brand_name: this.siteInfoService.getEtbaName(),
      Hotel_Country: this.siteInfoService.getEtbaCountry(),
      Hotel_City: this.siteInfoService.getEtbaCity(),
      Start_date: start,
      End_date: end,
      Adulte: nbrAdult,
      Children: nbrChild,
      Currency: currency,
      Hotel_Type: this.siteInfoService.getEtabData()['etabType'],
      Hotel_stars: this.siteInfoService.getEtabData()['etabStars'],
    });
  }

  setTranslation() {
    if(this.translate.currentLang != "en"){
      this.winRef.getTranslation("en").subscribe(res=>{
        this.en_translation={
          rooms: res.chamber,
          ligne_tarifiaires: res.lignetarifiercategorie
        }
      })
    } else {
      this.en_translation = {
        rooms: this.translate.translations.en.chamber,
        ligne_tarifiaires: this.translate.translations.en.lignetarifiercategorie
      }
    }
  }

  getInstant(key,rooms) {
    if(rooms){
     return get(this.en_translation.rooms,key.replace('chamber.','')) ;
    } else {
      return get(this.en_translation.ligne_tarifiaires,key.replace('lignetarifiercategorie.',''));
    }
  }

  sessionTimeOut() {
    this.gtm.push({
      event: "sessionTimeout",
    });
  }

  SoldoutRooms(startDate, endDate, nbrAdult, nbrChild, currency) {
    let start = moment(startDate).format("DD/MM/YYYY");
    let end = moment(endDate).format("DD/MM/YYYY");
    this.gtm.push({
      event: "soldout_room",
      Hotel_brand_name: this.siteInfoService.getEtbaName(),
      Hotel_Country: this.siteInfoService.getEtbaCountry(),
      Hotel_City: this.siteInfoService.getEtbaCity(),
      Start_date: this.getStartAndEndDates().start,
      End_date: this.getStartAndEndDates().end,
      Adulte: nbrAdult,
      Children: nbrChild,
      Currency: currency,
      Hotel_Type: this.siteInfoService.getEtabData()['etabType'],
      Hotel_stars: this.siteInfoService.getEtabData()['etabStars'],
    });
  }

  AvailibleRooms(startDate, endDate, nbrAdult, nbrChild, currency) {
    let start = moment(startDate).format("DD/MM/YYYY");
    let end = moment(endDate).format("DD/MM/YYYY");
    this.gtm.push({
      event: "availability_room",
      Hotel_brand_name: this.siteInfoService.getEtbaName(),
      Hotel_Country: this.siteInfoService.getEtbaCountry(),
      Hotel_City: this.siteInfoService.getEtbaCity(),
      Start_date: this.getStartAndEndDates().start,
      End_date: this.getStartAndEndDates().end,
      Adulte: nbrAdult,
      Children: nbrChild,
      Currency: currency,
      Hotel_Type: this.siteInfoService.getEtabData()['etabType'],
      Hotel_stars: this.siteInfoService.getEtabData()['etabStars'],
    });
  }

}